import EmployeeInfoComponents from "../components/EmployeeInfo";
import useEmployeeInfo from "../hooks/useEmployeeInfo";

function EmployeeInfo() {
  const employeeInfoProps = useEmployeeInfo();
  return <EmployeeInfoComponents {...employeeInfoProps} />;
}

export default EmployeeInfo;
